export const BUILD_MODE_LABELS = {
    dev: '개발',
    stage: '스테이지',
    product: '정식',
};

export const getBuildModeLabel = (mode) => BUILD_MODE_LABELS[mode] || mode || '-';

// 태그(main) 선택 시 정식, release 브랜치는 스테이지 여부에 따라 결정
export const resolveBuildMode = (version, isStage) => {
    if (!version) return null;
    if (version.type === 'tag') return 'product';
    return isStage ? 'stage' : 'dev';
};
